// You can customize below settings :)
const settings = {
  title: 'Cona CRM',
  showSettings: true,
  showTagsView: true,
  fixedHeader: false,
  showSidebarLogo: true,
  errorLog: ['production'],
  sidebarTextTheme: false,
  devServerPort: 9527
};
export default settings;